/// <reference path="../../../../app.definition.ts" />

import angular from "angular";
import 'angular-ui-bootstrap';
import { FieldService } from "@common/service/field.service";
import { FieldCategoryEnum } from "@common/model/analytics.model";


export class GenerateReportController {
    static $inject = ["$q", "$uibModalInstance", "$timeout", "FieldService", "settings"];

    constructor(
        private $q: angular.IQService,
        private $uibModalInstance: angular.ui.bootstrap.IModalInstanceService,
        private $timeout: angular.ITimeoutService,
        private FieldService: FieldService,
        private settings: any
    ) {
        this.init();
    }

    fields;
    fieldKeys;

    close = () => {
        this.$uibModalInstance.dismiss();
    }

    isDisabled = () => {
        if (!this.settings.requiredFields || !Array.isArray(this.settings.requiredFields)) {
            return false;
        } else {
            let isValid = true;
            this.settings.requiredFields.forEach(f => {
                isValid = isValid && !!this.fields[f].value && (!Array.isArray(this.fields[f].value) || this.fields[f].value.length > 0);
            });
            return !isValid;
        }
    }

    generateReport = () => {
        this.$uibModalInstance.close(this.fields);
        // $timeout returns a promise, avoiding the need for $q.defer()
        return this.$timeout(() => {
            // No-op, just creating a delay
        }, 1000);
    };

    init = () => {
        this.fields = this.FieldService.getFields(FieldCategoryEnum.INPUT);
        this.fieldKeys = this.FieldService.getFieldKeys(this.fields);
    }
}

angular.module('eCareVault.common.analyticsReport')
    .controller('GenerateReportController', GenerateReportController);
